/**
 * DailyQuote — a rotating daily motivational quote from athletes, coaches,
 * sports figures, and thought leaders. Changes daily; each audience differs.
 * Public endpoint, no auth. Props: audience ('student'|'teacher'|'parent'), variant ('dark'|'light').
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Quote } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const DailyQuote = ({ audience = 'student', variant = 'dark', className = '' }) => {
  const [q, setQ] = useState(null);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/api/academy/daily-quote?audience=${audience}`)
      .then((r) => { if (alive) setQ(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, [audience]);

  if (!q) return null;

  const light = variant === 'light';
  const styles = light
    ? { bg: 'linear-gradient(90deg, #f1ead7, #fbf7ec)', border: '#c9a961', accent: '#8a1c2b', text: '#1b3a63', sub: '#6b5f43' }
    : { bg: 'linear-gradient(90deg, rgba(255,94,0,0.10), rgba(0,0,0,0.25))', border: 'rgba(255,255,255,0.12)', accent: '#FF7A2F', text: '#f4f4f5', sub: '#a1a1aa' };

  return (
    <div
      className={`relative rounded-lg overflow-hidden px-5 py-4 sm:px-6 sm:py-5 ${className}`}
      style={{ background: styles.bg, border: `1px solid ${styles.border}` }}
      data-testid="daily-quote"
    >
      <div className="flex items-start gap-3">
        <Quote className="w-6 h-6 sm:w-7 sm:h-7 flex-shrink-0 mt-0.5" style={{ color: styles.accent }} />
        <div className="min-w-0">
          <div className="text-[8px] sm:text-[9px] font-black tracking-[0.3em] uppercase mb-1.5" style={{ color: styles.accent }}>
            Today's Motivation
          </div>
          <p className="text-sm sm:text-base font-medium italic leading-relaxed" style={{ color: styles.text }} data-testid="daily-quote-text">
            &ldquo;{q.quote}&rdquo;
          </p>
          <div className="mt-2 text-xs font-bold" style={{ color: styles.sub }} data-testid="daily-quote-author">
            — {q.author}<span className="font-normal opacity-80">, {q.author_title}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyQuote;
